export const positionConstants = {
    GET_SUCCESS: 'GET_POSITION_SUCCESS',

    ADD_SUCCESS: 'ADD_POSITION_SUCCESS',
    ADD_FAILURE: 'ADD_POSITION_FAILURE',

    DELETE_SUCCESS: 'DELETE_POSITION_SUCCESS',
    DELETE_FAILURE: 'DELETE_POSITION_FAILURE',

    UPDATE_SUCCESS: 'UPDATE_POSITION_SUCCESS',
    UPDATE_FAILURE: 'UPDATE_POSITION_FAILURE',

    CLEAR_ERROR: 'CLEAR_POSITION_ERROR_CODE'
};
